import { Heading, Flex } from '@dapperlabs/core-fe';
import React from 'react';

import { HowMomentsCard } from '../Cards/HowMomentsCard';
import { SectionProps } from '../models';
import SectionContainer from '../SectionContainer';

export const AboutGetMoments: React.FC<SectionProps> = ({
  cards,
  sectionHeading,
}) => {
  return (
    <SectionContainer>
      <>
        <Heading fontFamily='heading' textAlign='center'>
          {sectionHeading}
        </Heading>
        <Flex
          justify={['center', 'space-between']}
          direction={['column', 'column', 'row']}
          gap={['1rem', '1rem', '3rem']}
          pt={['0.5rem', '3rem']}
        >
          {cards.map(({ fields }) => (
            <HowMomentsCard
              key={fields.cardHeading}
              cardHeading={fields.cardHeading}
              cardImgSrc={fields.cardImage.fields.file.url}
              cardText={fields.cardText}
            />
          ))}
        </Flex>
      </>
    </SectionContainer>
  );
};
